import { render, staticRenderFns } from "./changemakers.vue?vue&type=template&id=5b1b160e&scoped=true&"
import script from "./changemakers.vue?vue&type=script&lang=js&"
export * from "./changemakers.vue?vue&type=script&lang=js&"
import style0 from "./changemakers.vue?vue&type=style&index=0&id=5b1b160e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b160e",
  null
  
)

export default component.exports